import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const accordionModule = () => {
  if (document.querySelectorAll(".accordion-module").length < 1) {
    return;
  }

  const accordion = document.querySelectorAll(".accordion-module__tab");
  accordion.forEach((element) => {
    const textHeight = element.querySelector(".accordion-module__tab-text").scrollHeight;
    element.addEventListener("click", () => {
      element.classList.toggle("active");
      if (element.classList.contains("active")) {
        element.querySelector(".accordion-module__tab-text").style.height = textHeight + "px";
        element.setAttribute("aria-expanded", "true");
      } else {
        element.querySelector(".accordion-module__tab-text").style.height = "0px";
        element.setAttribute("aria-expanded", "false");
      }
    });
  });

  // parallax effect
  const network = document.querySelector('.accordion-module .network');

  function createParallaxTimeline(triggerSelector, startYPercent, endYPercent, scaleTo) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: triggerSelector,
            scrub: 1,
            pin: false,
        }
    });

    tl.fromTo(triggerSelector, {
        yPercent: startYPercent,
        scale: 1,
        ease: 'none'
    }, {
        yPercent: endYPercent,
        scale: scaleTo,
        ease: 'none'
    });

    return tl;
  }

  function parallaxEffect() {
    network ? createParallaxTimeline(network, -9, 9, 1) : null;
  }

  parallaxEffect();
};

export default accordionModule;
